import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';

import { Row, Col, Card, CardBody, Button, Spinner } from 'reactstrap';

import Moment from 'react-moment';

import { Table, Column, HeaderCell, Cell } from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const TableHeight = 500;
const pound = `${'\u00A3'}`;

class SetupIntents extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    fetchStripeLoginLink: PropTypes.func.isRequired,
    getStripeCompanyStatus: PropTypes.func.isRequired,
    addStripeAccount: PropTypes.func.isRequired,
    getSinglePayment: PropTypes.func.isRequired,
    fetchPaymentTooltips: PropTypes.func.isRequired,
    resendEmail: PropTypes.func.isRequired,
    fetchLinkedAPIs: PropTypes.func.isRequired,
    checkCompStatus: PropTypes.func.isRequired,
    openCodePreview: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  componentDidMount() {
  }

  render() {
    const {
      onScroll,
      sort,
      acceptCustomRequest,
      declineCustomRequest,

      showNoPermission,
      dontShowPage,
      sortType,
      sortColumn,
      acceptSetupIntentProcessing,
      declineSetupIntentProcessing,

      setupIntents,
    } = this.props;

    return (
      <div>
        <Row style={{ marginTop: 15 }}>
          <Col style={{ fontSize: 14, paddingLeft: 35, color: '#616161', fontWeight: 700 }}>Custom Voucher Requests</Col>
          <Col style={{ fontSize: 14, float: 'right', textAlign: 'right', color: '#616161' }}>
            <div><b style={{ color: "#000" }}>See 'Extra Customer Choice' settings in Basic Information</b></div>
            <div>Requests will be automatically cancelled after 24 hours</div>
          </Col>
        </Row>
        <Table
          sortType={sortType}
          sortColumn={sortColumn}
          data={setupIntents || []}
          virtualized
          minHeight={TableHeight}
          height={TableHeight}
          headerHeight={64}
          shouldUpdateScroll={false}
          onSortColumn={sort}
          onScroll={onScroll}
          style={{ fontSize: 14, paddingLeft: 17, borderLeft: 0, borderRight: 0, borderBottom: 0 }}
          className="company-dashboard-campaigns-table"
          locale={{ emptyMessage: "No pending requests" }}
        >
          <Column width={170} sortable resizable>
            <HeaderCell>Date</HeaderCell>
            <Cell dataKey="date">
              {(rowData) => {
                return (
                  <div>
                    {rowData.date ? (
                      <Moment format="DD-MM-YYYY HH:mm" locale="=uk">
                        {rowData.date.seconds * 1000}
                      </Moment>
                    ) : (null)}
                  </div>
                );
              }}
            </Cell>
          </Column>
          {/*
          <Column width={200} sortable resizable>
            <HeaderCell>Status</HeaderCell>
            <Cell dataKey="status" />
          </Column> */}
          <Column width={150} sortable resizable>
            <HeaderCell>{`Face Value (${pound})`}</HeaderCell>
            <Cell dataKey="faceValue">
              {(rowData) => {
                if (rowData.faceValue) {
                  return <div> {rowData.faceValue ? (rowData.faceValue.toFixed ? rowData.faceValue.toFixed(2) : '') : '-'} </div>;
                } else {
                  return <div />;
                }
              }}
            </Cell>
          </Column>
          <Column width={150} sortable resizable>
            <HeaderCell>Discount (%)</HeaderCell>
            <Cell dataKey="discount">
              {(rowData) => {
                return <div> {rowData.discount ? `${rowData.discount}%` : '-'} </div>;
              }}
            </Cell>
          </Column>
          <Column width={170} sortable resizable>
            <HeaderCell>{`Voucher Price (${pound})`}</HeaderCell>
            <Cell dataKey="amount_captured_voucher">
              {(rowData) => (
                <>
                  <div> {rowData.amount_captured_voucher ? (rowData.amount_captured_voucher / 100).toFixed(2) : (rowData.amount ? (rowData.amount / 100).toFixed(2) : '-')} </div>
                </>
              )}
            </Cell>
          </Column>


          <Column width={150} resizable>
            <HeaderCell>Accept</HeaderCell>
            <Cell dataKey="refund button">
              {(rowData) => {
                  return (
                    <Button
                      color="link"
                      disabled={showNoPermission}
                      style={{ paddingTop: 3, paddingBottom: 3 }}
                      onClick={() => acceptCustomRequest(rowData.dbId)}
                    >
                      <>
                        Accept
                        {(acceptSetupIntentProcessing === rowData.dbId) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </>
                    </Button>
                  );
              }}
            </Cell>
          </Column>

          <Column width={150} resizable>
            <HeaderCell>Decline</HeaderCell>
            <Cell dataKey="refund button">
              {(rowData) => {
                  return (
                    <Button
                      color="link"
                      disabled={showNoPermission}
                      style={{ paddingTop: 3, paddingBottom: 3 }}
                      onClick={() => declineCustomRequest(rowData.dbId)}
                    >
                      <>
                        Decline
                        {(declineSetupIntentProcessing === rowData.dbId) ? (
                          <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
                        ) : (null)}
                      </>
                    </Button>
                  );
              }}
            </Cell>
          </Column>
        </Table>

        <div style={{ textAlign: 'left', fontSize: 14, color: '#616161' }}>
          To turn Voucher Requests on or off, please adjust your <Link style={{ fontWeight: 700, textDecoration: 'none' }} to="/basic-information">Extra Customer Choice</Link> settings.
        </div>
      </div >
    );
  }
}

export default withRouter(SetupIntents);
